/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * State of a synthesizer response.
 *
 * "Open" represents an open question;
 * "Answered" or "Closed" are terminal states.
 */
export var ResponseState;
(function (ResponseState) {
    ResponseState["OPEN"] = "open";
    ResponseState["ANSWERED"] = "answered";
    ResponseState["CLOSED"] = "closed";
})(ResponseState || (ResponseState = {}));
